import { render, staticRenderFns } from "./PcqDsiForm.vue?vue&type=template&id=d3a10f68&"
import script from "./PcqDsiForm.vue?vue&type=script&lang=js&"
export * from "./PcqDsiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports